import { render, staticRenderFns } from "./serviceManageHandle.vue?vue&type=template&id=5b8f9849&scoped=true&"
import script from "./serviceManageHandle.vue?vue&type=script&lang=ts&"
export * from "./serviceManageHandle.vue?vue&type=script&lang=ts&"
import style0 from "./serviceManageHandle.vue?vue&type=style&index=0&id=5b8f9849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f9849",
  null
  
)

export default component.exports